export const questions = {
    "quizTitle": "CAA Clasa D",
    "quizSynopsis": "Examen Clasa D · 26 întrebări · 30 min · minim 22 corecte",
    "progressBarColor": "#9de1f6",
    "nrOfQuestions": "371",
    "examConfig": {
        "personnelCategory": "CLASA D",
        "timeMinutes": 30,
        "passPercent": 85,
        "minCorrect": 22,
        "barem": null,
        "modelName": "Examen Clasa D",
        "sections": [
            {
                "id": "D-RND",
                "label": "Regulamentul de navigație pe Dunăre",
                "count": 10,
                "difficulty": 1
            },
            {
                "id": "D-Marinarie",
                "label": "Marinărie",
                "count": 6,
                "difficulty": 1
            },
            {
                "id": "D-Manevra",
                "label": "Conducerea și manevra ambarcațiunilor cu motor",
                "count": 6,
                "difficulty": 1
            },
            {
                "id": "D-PrimAjutor",
                "label": "Prim ajutor",
                "count": 2,
                "difficulty": 1
            },
            {
                "id": "D-Legislatie",
                "label": "Legislație maritimă",
                "count": 2,
                "difficulty": 1
            }
        ],
        "totalQuestions": 26
    },
    "appLocale": {
        "landingHeaderText": "<questionLength> Intrebari",
        "question": "Intrebare",
        "startQuizBtn": "Incepe",
        "resultFilterAll": "Toate",
        "resultFilterCorrect": "Correct",
        "resultFilterIncorrect": "Incorect",
        "prevQuestionBtn": "Inapoi",
        "nextQuestionBtn": "Inainte",
        "multipleSelectionTagText": "Selectie multipla",
        "resultPageHeaderText": "Ai terminat. Ai <correctIndexLength> raspunsuri corecte din <questionLength> total.",
        "pickNumberOfSelection": "Alege <numberOfSelection>",
        "marksOfQuestion": "(<marks> puncte)"
    },
    "questions": [
        {
            "question": "1. Intervalul între sunetele care compun \"o serie de sunete foarte scurte\" este de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) circa ½ s",
                "b) circa 1 s",
                "c) circa ¼ s"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "2. Pentru evitarea unui pericol iminent, conducătorii trebuie să ia toate măsurile cerute de împrejurări, chiar dacă se îndepărtează de la dispoziţiile R.N.D.?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Da",
                "b) Nu",
                "c) Numai pentru a salva nava"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "3. În caz de accident care pune în pericol persoanele care se găsesc la bord, conducătorul trebuie :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Să anunţe prin orice mijloace căpitănia portului cea mai apropiată pentru salvarea persoanelor",
                "b) Să se folosească de toate mijloacele care sunt la dispoziţia sa pentru salvarea acestor persoane",
                "c) Să ceară ajutor navelor care navigă în apropiere"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "4. Ce se înţelege prin termenul \"zi\" folosit în R.N.D ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Perioada cuprinsă între apusul şi răsăritul soarelui",
                "b) Nu este prevăzut în R.N.D.",
                "c) Perioada cuprinsă între răsăritul şi apusul soarelui"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "5. Toate navele fluviale trebuie să aibă mărci care indică linia maximă de încărcare ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Da, exclusiv micile ambarcaţiuni",
                "b) Da, inclusiv micile ambarcaţiuni",
                "c) Nu este prevăzut expres în R.N.D"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "6. Durata unui sunet lung este de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Circa 5 secunde",
                "b) Circa 6 secunde",
                "c) Circa 4 secunde"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "7. Conducătorii navelor remorcate trebuie să se conformeze ordinelor conducătorului convoiului ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Da",
                "b) Nu",
                "c) Numai în cazuri speciale"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "8. \"Bordul liber\" este :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Distanţa dinte linia de încărcare maximă şi pescajul navei",
                "b) Distanţa dintre linia de încărcare maximă şi linia de încărcare minimă",
                "c) Distanţa măsurată între planul de încărcare maximă şi suprafaţa punţii superioare în punctul ei cel mai de jos, sau în lipsa punţii, punctul cel mai de jos al părţii superioare a bordului fix"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "9. Ce se înţelege prin \"navă\" în sensul R.N.D. ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Mijlocul de navigaţie utilizat pentru realizarea activităţii de transport şi a altor servicii pe apă",
                "b) Navele de navigaţie interioară, inclusiv ambarcaţiunile mici şi bacurile, precum şi aparatele plutitoare şi navele maritime",
                "c) Navele maritime, fluviale, aparatele plutitoare, plute, nave militare etc"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "10. Ce se înţelege prin termenul de \"în staţionare\" folosit în R.N.D. ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) O navă, atunci când este legată la mal",
                "b) O navă sau un material plutitor asamblat când este legată la mal",
                "c) O navă, un material plutitor asamblat sau o instalaţie plutitoare atunci când este, în mod direct sau indirect ancorată sau legată la mal"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "11. Care sunt îndatoririle altor persoane care se găsesc la bordul navei :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Să se supună dispoziţiilor conducătorului navei, în interesul siguranţei navigaţiei şi ordinii la bord",
                "b) Să se supună dispoziţiilor conducătorului navei, numai la ambarcarea şi debarcarea lor",
                "c) Nu este prevăzut expres în R.N.D"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "12. Orice conducător de navă, dacă constată avarierea unei instalaţii de semnalizare (stingerea unei lumini, deplasarea unei geamanduri, distrugerea unui semnal etc.) este obligat :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Să ia măsuri imediate de remediere a semnalului avariat",
                "b) Să anunţe fără întârziere căpitănia de port cea mai apropiată asupra avarierii instalaţiei de semnalizare respectivă",
                "c) Să anunţe prin orice mijloc întreprinderea care are în administraţie întreţinerea şi semnalizarea căii navigabile"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "13. Ce se înţelege prin \"marş\" în sensul R.N.D. :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Când o navă, un material plutitor asamblat sau o instalaţie plutitoare, nu este direct, nici în ancoră, nici legată la mal şi nici eşuată",
                "b) O navă atunci când navigă chiar şi în derivă",
                "c) O navă când nu este ancorată sau legată"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "14. Navele de pasageri pot transporta un număr de pasageri corespunzător :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Planurilor de construcţie ale navei",
                "b) Instrucţiunilor şantierului constructor",
                "c) Autorizaţiei organelor competente"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "15. Ce se înţelege prin termenul de “noapte” în sensul R.N.D. ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Perioada cuprinsă între răsăritul şi apusul soarelui",
                "b) Perioada cuprinsă între apusul şi răsăritul soarelui",
                "c) Nu este prevăzut în R.N.D"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "16. Durata unui sunet scurt este de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Circa o jumătate de secundă",
                "b) Circa 1 secundă",
                "c) Circa ¼ secundă"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "17. Scări de pescaj poartă navele care au pescajul de cel puţin :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 1 m",
                "b) 0,50 m",
                "c) 1,20 m"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "18. Ce se înţelege prin “ambarcaţiune mică”, în sensul R.N.D. ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Orice navă cu lungimea corpului mai mică de 20 m, cu excepţia ambarcaţiunior mici care remorchează, împing sau duc cuplat nave, altele decât ambarcaţiuni mici, precum şi a bacurilor şi navelor autorizate să transporte mai mult de 12 pasageri",
                "b) Nave a căror lungime şi lăţime ale corpului sunt mai mici de 15 m şi respectiv, 3,50m sau al căror deplasament mediu este mai mic de 15 t, cu excepţia bacurilor, navelor care remorchează, împing sau duc cuplat nave, în afara ambarcaţiunilor mici",
                "c) Nave a căror lungime şi lăţime ale corpului sunt mai mici de 15 m şi respectiv, 3,50 m sau al căror deplasament maxim este mai mic de 10 t, cu excepţia bacurilor, navelor care remorchează, împing sau duc cuplate nave, în afara ambarcaţiunilor mici"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "19. Ce se înţelege prin “serie de sunete foarte scurte “ ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) O serie de cel puţin 6 sunete cu o durată de circa ¼ de secundă fiecare",
                "b) O serie de cel puţin 5 sunete cu o durată de ½ de secundă fiecare",
                "c) O serie de cel puţin 7 sunete cu o durată de ⅓ de secundă fiecare"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "20. În scopul evitării de a pune în pericol viaţa persoanelor sau de a provoca pagube altor nave, conducătorii pot lua toate măsurile de precauţie, chiar dacă nu sunt prevăzute dispoziţii speciale în R.N.D. ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Da",
                "b) Nu",
                "c) Numai pentru a salva echipajul"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "21. Ce obligaţii aveţi dacă sunteţi conducătorul unei nave şi vă găsiţi în apropierea altei nave avariate, ale cărei persoane sunt în pericol sau nava poate deveni un obstacol pentru navigaţie ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) În măsura în care nu puneţi în pericol siguranţa propriei nave, daţi asistenţă imediat",
                "b) Fiind vorba de persoane în pericol, daţi asistenţă imediat",
                "c) Anunţaţi cea mai apropiată căpitănie de port"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "25. Ce se înţelege prin termenul “navă care pescuieşte” ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Orice navă care pescuieşte cu ajutorul plasei, a cârmacei, cu traul sau alte mijloace de pescuit care-i reduc capacitatea de manevră",
                "b) Nava construită şi dotată pentru a pescui",
                "c) O navă care pescuieşte cu cârlige sau alte unelte de pescuit, care nu-şi reduce capacitatea de manevră"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "26. Ce se înţelege prin termenul “serie de bătăi de clopot“ ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Înseamnă două lovituri de clopot",
                "b) Înseamnă trei lovituri de clopot",
                "c) Înseamnă patru lovituri de clopot"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "27. Cum pot fi folosite luminile şi proiectoarele ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Este interzis a se folosi lumini sau proiectoare astfel ca ele să poată fi confundate cu luminile sau semnalele menţionate în R.N.D. sau care pot dăuna asupra vizibilităţii acestor lumini sau semnale, sau ca ele să producă o orbire care constituie un pericol pentru navigaţie ori pentru circulaţia terestră",
                "b) Este interzisă cu desăvârşire folosirea lor în R.N.D",
                "c) Nu se precizează folosirea lor în R.N.D"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "28. Care este intensitatea şi arcul de orizont la care poate fi văzută o lumină albă din pupa unei nave ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Clară, 112° 30’",
                "b) Obişnuită, 1370",
                "c) Obişnuită, 1350"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "29. Ce lumini poartă navele ce navigă cu vele ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Două lumini, obişnuite sau clare suprapuse vizibile din toate părţile din care lumina superioară trebuie să fie roşie, iar lumina inferioară verde; aceste lumini trebuie să fie dispuse într-un loc corespunzător, în partea superioară sau în vârful catargului, la o distanţă de cel puţin 1 m una de cealaltă. Luminile din borduri verde/roşu obişnuite şi lumina albă obişnuită de pupa",
                "b) O lumină albă obişnuită, iar la apropierea de o altă navă arată o a doua lumină albă obişnuită la prova",
                "c) Două lumini albe obişnuite la prova"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "30. Ce lumini trebuie să poarte, noaptea, ambarcaţiunile mici autopropulsate, a căror lungime a corpului nu depăşeşte 20 m, care remorchează sau duc în cuplu ambarcaţiuni mici ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nu este prevăzut în R.N.D.",
                "b) Luminile unei nave autopropulsate, cu convoi remorcat sau în cuplu",
                "c) Luminile unei ambarcaţiuni mici autopropulsate ce navigă izolat şi a cărei lungime nu depăşeşte 20 m"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "31. Ce lumini pot să poarte noaptea, ambarcaţiunile mici autopropulsate, ce nu depăşesc 7 m, în marş ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) O lumină albă obişnuită, dispusă într-un loc corespunzător şi la o înălţime de la care să fie vizibilă din toate părţile",
                "b) Două lumini albe obişnuite la catarg",
                "c) Luminile unei nave autopropulsate în marş"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "32. Ambarcaţiunea mică legată la mal, noaptea, cu excepţia bărcilor de serviciu ale navelor trebuie să poarte :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) O lumină albă obişnuită dispusă într-un loc corespunzător şi la o astfel de înălţime încăt să fie vizibilă din toate părţile",
                "b) Nu este obligatorie semnalizarea",
                "c) O lumină albă obişnuită dispusă la cel puţin 3 m deasupra liniei de încărcare maximă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "33. Plasele sau alte unelte de pescuit ale navelor care pescuiesc, ziua întinse în apropierea şenalului şi care pot prezenta o piedică pentru navigaţie, vor fi semnalizate cu :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Geamanduri, în număr suficient fiecare, purtând câte un pavilion alb pentru a indica poziţia lor",
                "b) Flotoare sau pavilioane galbene, în număr suficient pentru a indica poziţia lor",
                "c) Orice obiecte plutitoare, în număr suficient pentru a indica poziţia lor"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "34. Ce lumini trebuie să aibă o ambarcaţiune mică cu rame, noaptea în marş ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Trebuie să arate o lumină albă obişnuită vizibilă din toate părţile la apropierea altor nave",
                "b) O lumină albă obişnuită, vizibilă pe întreg orizontul (360°)",
                "c) O lumină albă obişnuită, vizibilă pe un arc de orizont de 225°"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "35. Ce lumini trebuie să poarte navele cu vele în marş şi unde ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Luminile unei nave izolate autopropulsate în marş sau dacă sunt ambarcaţiuni mici, luminile ambarcaţiunilor mici",
                "b) O singură lumină albă obişnuită, iar la apropierea de o navă să arate o a doua lumină albă la prova",
                "c) Două lumini obişnuite sau clare suprapuse vizibile din toate părţile, din care lumina superioară trebuie să fie roşie, iar lumina inferioară verde. Aceste lumini trebuie să fie dispuse, într-un loc corespunzător în partea superioară sau în vârful catargului la distanţă de cel puţin 1 m una de cealaltă. Luminile din borduri verde şi roşu şi lumina albă de pupa"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "36. O navă care navigă cu vele folosind în acelaşi timp şi motor, ziua în marş, trebuie să poarte:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) O bulă neagră dispusă la cel puţin 3 m deasupra liniei de maximă încărcare astfel încât să fie vizibilă în toate părţile",
                "b) Un con negru cu vârful în jos, amplasat cât mai sus posibil şi într-un loc unde va fi cel mai vizibil",
                "c) Un con negru cu vârful în sus dispus la cel puţin 3 m deasupra liniei de maximă încărcare, astfel încât să fie vizibil în toate părţile"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "37. Semnalizarea prevăzută pentru noapte la nave trebuie să fie purtată, în plus, şi ziua , în condiţii de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Vizibilitate redusă : ceaţă, ninsoare etc",
                "b) Avarie la bordul navei",
                "c) Răniţi sau bolnavi la bord"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "38. Care este semnalizarea suplimentară a navelor de supraveghere fluvială ziua în marş în exercitarea atribuţiunilor lor :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Ca a unei nave izolate",
                "b) Ziua arborează o flamură albă în centrul căreia se găseşte un romb alb încadrat de un chenar albastru",
                "c) Ziua arborează o flamură albă în centrul căreia se găseşte un romb alb încadrat cu un chenar albastru şi arată o lumină albastră intermitentă"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "39. Emiterea de către o navă a unui semnal fonic lung pe vizibilitate bună are semnificaţia de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Navigaţie periculoasă",
                "b) Atenţie",
                "c) Semnal premergător intenţiei de a depăşi"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "40. Care este culoarea, forma şi care sunt caracteristicile unei geamanduri de bifurcaţie ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) De formă sferică vopsită (piturată) în verde-roşu-verde-roşu, lumină de culoare albă intermitentă",
                "b) De formă sferică vopsită (piturată) în alb- negru-alb-negru, lumină de culoare albă intermitentă",
                "c) De formă sferică vopsită (piturată) în roşu- negru-roşu-negru, lumină de culoare albă intermitentă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "41. Care sunt caracteristicile luminii de coastă (far) de bifurcaţie ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Două panouri triunghiulare albe, unul deasupra celuilalt şi opuse la vârf, cel de deasupra mărginit cu bandă roşie cel de jos cu bandă verde, lumină albă intermitentă",
                "b) Suport de culoare albă, lumină galbenă fixă, un disc piturat negru-roşu-negru- roşu",
                "c) Suport de culoare albă, lumină albă fixă, un disc piturat roşu-negru-roşu-negru"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "42. Atunci când o navă este în pericol şi vrea să ceară ajutor, poate emite semnale sonore ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Da",
                "b) Nu",
                "c) Nu este prevăzut în R.N.D."
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "43. Şcondrii pentru dreapta au culoarea :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Verde",
                "b) Neagră",
                "c) Roşie"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "44. Se pot folosi lumini şi semnale ce nu sunt prevăzute în R.N.D ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nu sunt permise alte semnale decât cele prevăzute în R.N.D",
                "b) Da, numai pentru comunicări între nave, între nave şi uscat, cu condiţia să nu se confunde cu luminile şi semnalele prevăzute de R.N.D",
                "c) Da, numai în sectorul Dunării maritime"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "45. Pe întregul parcurs navigabil al fluviului, şenalul este balizat după sistemul :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Lateral",
                "b) Cardinal",
                "c) Lateral şi cardinal"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "46. Atunci când o navă aflată în pericol vrea să ceară ajutor, ea poate să emită :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) “O serie de sunete de clopot”",
                "b) “O serie de cinci sunete lungi” la interval de un minut",
                "c) “O serie de sunete de clopot” sau “sunete lungi” cu alte mijloace acustice repetate"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "47. Nava care emite, “serie de sunete foarte scurte” ce semnalizează ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Este în imposibilitatea de manevră",
                "b) Este în pericol şi cere ajutor",
                "c) Este în pericol iminent de abordaj"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "48. Şcondri pentru stânga au culoarea :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Verde",
                "b) Neagră",
                "c) Roşie"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "49. Care este forma, culoarea şi care sunt caracteristicile unei geamanduri pentru stânga ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) De formă sferică, piturată în negru-roşu- negru-roşu, lumina de culoare albă intermitentă",
                "b) De formă conică, piturată în verde, lumina de culoare verde intermitentă",
                "c) De formă cilindrică, piturată în roşu, lumina de culoare roşie intermitentă"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "50. Cum semnalizează noaptea navele care sunt în pericol şi cer ajutor ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Agită circular o lumină",
                "b) Aprind o lumină roşie intermitentă",
                "c) Agită o lumină indiferent de culoare"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "51. Geamandurile de culoare verde cu lumină verde intermitentă balizează :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Partea stângă a şenalului şi pericolele de la malul stâng",
                "b) Partea dreapta a şenalului şi pericolele de la malul drept",
                "c) Pericolele de navigaţie situate în şenal"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "52. Lumina de coastă (far) de pe malul stâng, are următoarele caracteristici :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Suport de culoare albă, lumină de culoare verde intermitentă şi un panou de formă rombică, piturat jumătate verde-partea de sus şi jumătate alb-partea de jos",
                "b) Suport de culoare albă, lumină de culoare verde intermitentă şi un panou dreptunghiular, piturat la partea superioară şi inferioară cu câte o dungă albă, iar între cele două dungi albe piturat cu roşu",
                "c) Suport de culoare albă, cu lumină de culoare roşie intermitentă şi un panou de formă rombică, piturat jumătate negru la partea superioară şi jumătate alb la partea inferioară"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "53. Geamandurile luminoase şi neluminoase, şcondrii şi jaloanele pentru dreapta sau pentru stânga, în principiu ce marchează ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Limita şenalului şi pericolele de la malul respectiv",
                "b) Pericolele de navigaţie situate în şenal",
                "c) Pericolele de la malul respectiv"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "54. Lumina de coastă (far) de pe malul drept şi lumina de coastă (far) de pe malul stâng în principiu indică :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Pericolele din apropierea malurilor şi în acelaşi timp apropierea şenalului de maluri",
                "b) Direcţia aproximativă a şenalului în raport cu malul şi serveşte în acelaşi timp ca punct de reper",
                "c) Direcţia şenalului în raport cu pericolele de la maluri"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "55. Navele care sunt în pericol şi cer ajutor, ce semnal vizual arată ziua ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Agită un pavilion alb",
                "b) Agită circular un pavilion sau orice alt obiect asemănător",
                "c) Agită circular un balon roşu"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "56. Ce semnificaţie au geamandurile de culoare roşie cu lumina roşie intermitentă ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Marchează limitele şenalului şi direcţia sa, balizând partea stângă a şenalului şi pericolele de la malul stâng",
                "b) Marchează limitele şenalului şi direcţia sa, balizând partea dreaptă a şenalului şi pericolele de la malul drept",
                "c) Balizează pericolele de navigaţie situate în şenal"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "57. Lumina de coastă (far) de pe malul drept are următoarele caracteristici:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Suport de culoare albă, lumină de culoare verde intermitentă şi un panou pătrat roşu, mărginit de două benzi orizontale albe",
                "b) Suport de culoare albă, lumină de culoare roşie intermitentă şi un panou pătrat roşu, mărginit de două benzi orizontale albe",
                "c) Suport de culoare albă, lumină de culoare roşie intermitentă şi un panou pătrat verde mărginit de două benzi orizontale albe"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "58. Ce semnificaţie au geamandurile luminoase şi neluminoase, şcondrii şi jaloanele de joncţiune şi de bifurcaţie ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Semnalizează numai joncţiunea şi bifurcaţia şenalului",
                "b) Balizează numai pericolele de navigaţie situate pe şenal",
                "c) Semnalizează joncţiunea şi bifurcaţia şenalului şi în afară de aceasta balizează pericolele de navigaţie din şenal"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "59. Care este forma, culoarea şi care sunt caracteristicile luminii unei geamanduri pentru dreapta ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) De formă sferică, piturată în negru–roşu- negru–roşu, lumina de culoare albă intermitentă",
                "b) De formă conică, piturată în negru, lumina de culoare verde intermitentă",
                "c) De formă cilindrică, piturată în roşu, lumina de culoare roşie intermitentă"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "60. Jaloanele de aliniament indică :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Axa traversării",
                "b) Pericolele de navigaţie de la malul drept sau stâng",
                "c) Începutul sau sfârşitul traversării şenalului"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "61. Ambarcaţiunile mici care navigă izolat şi convoaiele remorcate sau formaţiunile în cuplu compuse numai din ambarcaţiuni mici, sunt obligate :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Să nu jeneze mişcările şi manevrele celorlalte nave",
                "b) Să traverseze calea navigabilă numai în porturi",
                "c) Să navige numai ziua"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "62. Toate navele trebuie să treacă în timpul cel mai scurt posibil trecerile înguste ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Nu",
                "b) Nu este prevăzut în R.N.D.",
                "c) Da"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "63. Cine cedează drumul în cazul întâlnirii dintre două ambarcaţiuni mici, dintre care una este autopropulsată şi cealaltă nepropulsată ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Ambarcaţiunea autopropulsată",
                "b) Ambarcaţiunea nepropulsată",
                "c) Ambele, după ce în prealabil s-au înţeles prin semnale"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "64. Amonte pe calea navigabilă este sensul :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Spre izvor",
                "b) Spre revărsare",
                "c) De la un mal la celălalt"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "65. Este interzis a se angaja cu o navă în intervalele dintre unităţile unui convoi remorcat ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Da",
                "b) Nu",
                "c) Nu este prevăzut în Regulament"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "66. Unde este interzis de a se instala plase sau alte unelte de pescuit ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) În canale navigabile",
                "b) În locurile de ancoraj",
                "c) În şenalul navigabil"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "67. Când nu se aplică interdicţia de a se lăsa să se târască ancore, parâme sau lanţuri ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) În cazul micilor deplasări la locurile de staţionare sau în cazul manevrelor",
                "b) Întotdeauna, în sectoarele unde este permisă ancorarea",
                "c) Când şenalul are o lăţime absolut suficientă, iar adâncimile trec de 6 m"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-RND",
            "difficulty": 1
        },
        {
            "question": "68. Piesa de rezistenta situata in extremitatea prova, constituind o prelungire a chilei , se numeşte",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) contrachila",
                "b) etrava",
                "c) carlinga"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "69. Ce reprezintă un cui de strapazan?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un cui de lemn folosit la asamblarea pieselor de rezistenta",
                "b) un cui de lemn bătut in marginea bordajului , vertical de care se prinde rama",
                "c) un cui de lemn , aşezat la prova de care se leagă barca"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "70. La ce foloseşte podul in cazul zalei de ancora",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) zalele de ancora nu au pod",
                "b) la ghidare pe nara de ancora",
                "c) măreşte rezistenta la întindere si împiedica încurcarea"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "71. Barbetele sunt bucăți de parâmă fixate la prova si pupa bărcii și servesc",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) pentru amaraj",
                "b) in cazul unei persoane cazuta peste bord",
                "c) pentru legare sau remorcat"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "72. Parâma obţinută din răsucirea a trei șuvite se numeşte",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) paramã simplã sau lanƫanã",
                "b) paramã simplã sau garlin",
                "c) paramã simplã sau cordon"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "73. Apărătoarele gaşelor mici la parâme se numesc",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) guardaman",
                "b) rodante",
                "c) binte"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "74. Babalele sunt piese metalice din fontă sau oțel , simple sau duble și servesc pentru",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) întărirea structurii de rezistenta a navei",
                "b) ancoraj",
                "c) luarea voltelor cu parâme"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "75. La navele mici locul babalelor poate fi luat de",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) trancheti",
                "b) tacheti",
                "c) turnicheti"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "76. La ce foloseşte operaţiunea de matisire?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) împreunarea a doua capete de parâma sau realizarea unei gaşe",
                "b) trecerea de la o parâma mai groasa spre una mai subţire",
                "c) sporirea rezistentei la rupere a parâmei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "77. Ce reprezintă voltele?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) legăturile prin care parâmele se fixează la dispozitivele de legare existente la bord",
                "b) totalitatea manevrelor mobile de la bord",
                "c) ochiurile făcute de o parâma semirigida"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "78. În cazul unei rame, pana reprezintă",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) îngroşarea braţului imediat după manşon",
                "b) partea ramei din care este manevrata",
                "c) partea lata in forma de lopata"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "79. În general o ancoră se compune din următoarele părţi :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) braţe , fus , diamant , inel , traversa",
                "b) traverse, braţe , diamant si eche",
                "c) inel , traversa, braţe si pana"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "80. Ce înţelegeţi prin graparea ancorei :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) ancora si lanţul sunt suprasolicitate",
                "b) ancora se taraste pe fundul apei",
                "c) ancora s-a agatat intr-un corp dur pe fundul apei"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "81. Dacă o parâmă intră în compunerea altei parâme, mai groase, aceasta va purta denumirea de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) lanƫanã",
                "b) garlin",
                "c) cordon"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "82. Adâncimea apei se măsoară cu:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) lochul",
                "b) sonda",
                "c) barometrul"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "83. Fiecare rând de scânduri sau de table al învelişului (bordajului) exterior se numeşte :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) traversa",
                "b) copastie",
                "c) fila"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "84. Un observator care stă pe puntea navei cu fața spre prova, are în dreapta",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) bordul tribord",
                "b) bordul tribord",
                "c) cuplul maestru"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "85. Cârma se compune din :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) panã si eche",
                "b) dame si eche",
                "c) panã si dama"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "86. Ancora cu patru braţe este folosită :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la fluviu si ape interioare",
                "b) în golfuri si estuare",
                "c) la mare in ape de adâncime medie"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "87. O baba simplă, formată dintr-o singură coloană prevăzută cu traversă se numeşte :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) tranchet",
                "b) turnichet",
                "c) binta"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "88. Piesele metalice de ghidare a parâmelor care au rol de a elimina frecarea se numesc",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) binte",
                "b) babale",
                "c) turnicheti"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "89. Ce reprezintă patronarea unei parâme ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) protejarea contra frecării , prin învelirea unei porţiuni",
                "b) infasurarea capetelor ca sa nu se destrame",
                "c) eliminarea unei porţiuni uzate"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "90. Piesa fundamentală de rezistență a oricărei nave, situată în plan diametral, de la prova la pupa, se numeşte",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) chila",
                "b) etrava",
                "c) etambou"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "91. Care este elementul de bază la structura oricărui tip de parâmă",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) lanƫana",
                "b) firul",
                "c) garlinul"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "92. Piesele metalice mai mici, care servesc la luarea voltelor cu parâme mai subţiri se numesc",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) tacheti",
                "b) trancheti",
                "c) turnicheti"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "93. Dispozitivele de construcție specială, fixate în bordaj, cu rol de ghidare a parâmei se numesc",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) rodante",
                "b) urechi",
                "c) tacheţi"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "94. Orificiul rotund prin care trece axul cârmei se numeşte",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) stelatura pupa",
                "b) etrava",
                "c) etambreu"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "95. Viteza unei ambarcaţiuni se măsoară cu",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Sonda",
                "b) Barometrul",
                "c) Lochul"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "96. Dama reprezintă",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o scobitura in marginea superioara a bordajului , in care se introduce rama",
                "b) partea cea mai lata a ambarcaţiunii",
                "c) locul in care se întâlnesc filele de bordaj cu copastia"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "97. In cazul unei ancore, diamantul este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) locul de unde se leagă capătul lanţului",
                "b) ramificaţia braţelor",
                "c) locul de împreunare a braţelor cu fusul"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "98. Cum se măsoară calibrul lanţului de ancoră",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) grosimea la mijlocul zalei",
                "b) lăţimea maxima a zalei la interior",
                "c) lungimea maxima a zalei la exterior"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "99. Dispozitivele de construcţie specială, fixate în punte, cu rol de ghidare a parâmei se numesc",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) rodante",
                "b) urechi",
                "c) tacheti"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "101. Vartejul este :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) piesa de legatura inte cheia de impreunare a ancorei si cea a lantului de ancora",
                "b) o za de lat de ancora",
                "c) o cheie de impreunare"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "102. Orificiul rotund prin care trece axul elicii de propulsie se numeşte",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) etambou",
                "b) selatura pupa",
                "c) etambreul axului elicii"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "103. Un observator care stă pe puntea navei cu fața spre prova, are in dreapta",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) bordul babord",
                "b) bordul tribord",
                "c) cuplul maestru"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "104. Elementele de osatură transversale, fixate pe chilă la intervale egale, se numesc",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) file lacrimare",
                "b) coaste",
                "c) traverse"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "105. Locul de îmbinare a filelor lăcrimare se numeşte",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cusătura",
                "b) gurna",
                "c) binta"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "106. Din punct de vedere al materialului folosit la confecționarea parâmelor, una din categoriile incluse în această clasificare o reprezintă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) paramele vegetale",
                "b) paramele rasucite (garline)",
                "c) paramele simple (lantane)"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "107. La parâmele vegetale și sintetice circumferința reprezintă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) greutatea",
                "b) grosimea",
                "c) rezistenta"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "108. Chila reprezinta:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) element de rezistenta al navei dispus in planul transversal al navei",
                "b) element de rezistenta dispus in planul longitudinal al navei",
                "c) element de rezistenta dispus in planul cuplului maestru"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "109. Sarcina la care parama se rupe reprezinta:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) grosimea paramei",
                "b) greutatea paramei",
                "c) rezistenta paramei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "110. Ce este merlinul?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o lantana de 40-80mm grosime folosita la legarea navelor mici",
                "b) o parama cu grosimea de 100-620mm folosita la legarea sau remorcarea navei",
                "c) o lantana subtire de 7-8mm folosita la infasurari si patronari de parame groase"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "111. Raiul unei macarale este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o rola care se invarteste liber in jurul unui ax",
                "b) o piesa formata din doua placi laterale ovale si doua tocuri",
                "c) piesa de sustinere a macaralei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "112. Etrava reprezinta:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prelungirea chilei in tribord si babord",
                "b) prelungirea chilei in prova",
                "c) prelungirea chilei in pupa"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "113. Care din urmatoarele parame au in interior o inima vegetala, pentru protectia acestora?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) paramele sintetice",
                "b) paramele vegetale",
                "c) paramele metalice"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "114. Capacitatea paramei de a se indoi, fara a-si modifica structura interioara, reprezinta:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) flexibilitatea paramei",
                "b) greutatea paramei",
                "c) rezistenta paramei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "115. Ce este grandeea?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o lantana cu circumferinta de 25-120mm",
                "b) o parama cu grosimea de 100-620mm folosita la legarea sau remorcarea navei",
                "c) o lantana subtire de 7-8mm folosita la infasurari si patronari de parame groase"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "116. Sbirul este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o rola care se invarteste liber in jurul unui ax",
                "b) o piesa formata din doua placi laterale ovale si doua tocuri",
                "c) inel de parama confectionat prin matisire care serveste la prinderea unui palanc pe o parama sau pe un scondru"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "117. Etamboul reprezinta:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prelungirea chilei in tribord si babord",
                "b) prelungirea chilei in prova",
                "c) prelungirea chilei in pupa"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "118. Caracteristicile paramelor sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) grosimea, flotabilitatea, greutatea, rezistenta, elasticitatea",
                "b) grosimea, greutatea, rezistenta, flexibilitatea, elasticitatea",
                "c) grosimea, flotabilitatea, greutatea, elasticitatea, asieta"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "119. Ce se intelege prin \"bataia paramei\"?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) separara firelor dupa lungime si eliberarea produsului secundar numit stupa",
                "b) indepartarea materialelor straine din materia prima",
                "c) operatiunea prin care firele sunt rasucite"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "120. Ce este saula?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o lantana de 40-80mm grosime folosita la legarea navelor mici",
                "b) o parama cu grosimea de 100-620mm folosita la legarea sau remorcarea navei",
                "c) o parama cu grosimea de 15-40mm folosita la bandula sau la pavilion"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "121. Macaralele in marinarie sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) dispozitive de genul scripetilor, folosite pentru ridicarea unor greutati sau pentru schimbarea directiei de tractiune a unei parame",
                "b) instalatii de forta prevazute cu cabina si panou de comanda",
                "c) instalatii compuse dintr-un ansanmblu de grinzi metalice sudate sau nituite, aflate pe nave"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "122. Coastele reprezinta elemente de constructie ale navei dispuse in planul:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) liniei de plutire",
                "b) longitudinal",
                "c) transversal"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "123. Pescajul navei reprezinta:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) distanta masurata pe orizontala in planul cuplului maestru, la nivelul liniei de plutire de plina incarcare",
                "b) distanta masurata pe orizontala in planul cuplului maestru, intre extremitatile celor doua borduri",
                "c) distanta masurata pe verticala, de la linia de baza pana la linia de plutire"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "125. Ce se intelege prin \"pieptanarea paramei\"?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) separarea firelor dupa lungime si eliberarea produsului secundar, numit stupa",
                "b) indepartarea materialelor straine din materia prima",
                "c) operatiunea prin care firele sunt rasucite"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "126. Ce este lusinul?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o lantana de 40-80mm grosime folosita la legarea navelor mici",
                "b) o lantana mai fina decat merlinul, folosita la patronari si infasurari fine",
                "c) o parama cu grosimea de 15-40mm folosita la bandula sau la pavilion"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "127. Partile componente ale unei macarale sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) capatana, raiul, sbirul",
                "b) capatana, raiul, troliul",
                "c) capatana, raiul, spiraiul"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "128. Varangele reprezinta elemente de constructie ale navei dispuse in planul:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) liniei de plutire",
                "b) longitudinal",
                "c) transversal"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "129. Ce este flotabilitatea?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) proprietatea navei de a reveni la pozitia initiala, dupa ce a fost scoasa din starea de echilibru",
                "b) proprietatea navei de a pluti, la pescajul mediu determinat, cu incarcatura sa",
                "c) proprietatea navei de a-si schimba directia miscarii"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "130. Pastrarea paramelor vegetale se face ferindu-le de:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) razele solare",
                "b) umezeala",
                "c) nu necesita masuri speciale pentru pastrare"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "131. Ce se intelege prin \"toarcerea paramei\"?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) separarea firelor dupa lungime si eliberarea produsului secundar, numit stupa",
                "b) indepartarea materialelor straine din materia prima",
                "c) operatiunea prin care firele sunt rasucite spre dreapta"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "132. Ce este garlinul?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o lantana de 40-80mm grosime folosita la legarea navelor mici",
                "b) o parama cu grosimea de 100-620mm folosita la legarea sau remorcarea navei",
                "c) o lantana subtire de 7-8mm folosita la infasurari si patronari de parame groase"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "133. Palancurile sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) dispozitive compuse din una sau mai multe macarale cu cate unul sau mai multe raiuri, prin care se trece o parama denumita curent",
                "b) instalatii compuse din grinzi de otel sudate sau imbinate prin nituire",
                "c) ansamble alcatuite din mai multe bigi sau cranice, folosite la ridicarea de greutati si deschiderea capacelor de magazii"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "134. Elementul de baza din structura oricarei parame este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) suvita",
                "b) firul",
                "c) lantana"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "135. Din ce sunt confectionate paramele metalice?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) din fire de canepa, in, bumbac, iuta",
                "b) din fire de sarma de otel zincat cu grosimi de 0,2-0,6mm",
                "c) din fire de capron, relon, nailon, polipropilena"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "136. Mandarul simplu este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) dispozitiv de ridicat, alcatuit din doua macarale duble",
                "b) dispozitiv de ridicat alcatuit dintr-o macara fixa, prin care trece o parama",
                "c) dispozitiv de ridicat alcatuit dintr-o macara mobila, prin care trece un curent"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "137. Paramele simple se numesc si:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) garline",
                "b) lantane",
                "c) cordoane"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "138. Din ce sunt confectionate paramele vegetale?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) din fire de canepa, in, bumbac, iuta",
                "b) din fire de sarma de otel zincat cu grosimi",
                "c) din fire de capron,relon,nailon,"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "139. Furchetii sunt :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) piese metalice in forma de furca pe care se sprijina ramele ambarcatiunii",
                "b) montant de copastie",
                "c) nu sunt necesari pentru ambarcatiuni"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "140. Din ce sunt confectionate paramele sintetice?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) din fire de canepa, in, bumbac, iuta",
                "b) din fire de sarma de otel zincat cu grosimi de 0,2-0,6mm",
                "c) din fire de capron, relon, nailon, polipropilena"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "141. Mai multe fire rasucite intre ele formeaza:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o suvita",
                "b) o lantana",
                "c) o sfilata"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "143. Ce sunt paramele de sizal?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) parame vegetale confectionate din fire lungi de canepa",
                "b) parame vegetale confectionate din fibre de bananaier",
                "c) parame vegetale confectionate din frunze de cactus"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "144. Unde se pastreaza paramele pentru uzul curent?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) in magazii",
                "b) pe punte",
                "c) intr-un cofferdam"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "145. Vesta de salvare asigura:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) iesirea la suprafata a persoanei cazute in apa,chiar in stare de inconstienta,si mentine gura acesteia deasupra nivelului apei",
                "b) la confectionarea baloanelor si paietelor",
                "c) la confectionarea saulelor la ambarcatiuni sport si de agrement"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "146. Ce trebuie verificat la primirea paramelor vegetale la bord?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) culoarea si mirosul",
                "b) calitatea zincarii",
                "c) sa nu fie indoite"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "147. La ce sunt folosite paramele de canepa?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la confectionarea manevrelor curente, la barci si la arborada",
                "b) la confectionarea baloanelor si paietelor",
                "c) la confectionarea saulelor, la ambarcatiuni sportive si de agrement"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "148. Barbetele sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) parame folosite pentru prinderea butoaielor si ridicarea acestora",
                "b) capete de parama folosite la botare",
                "c) capete de parama fixate la prova si la pupa barcii."
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "149. Boturile sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) capete de parama vegetala sau de lant fixate cu unul din capete solid in punte pentru fixarea provizorie a unei parame.",
                "b) sigurante ale axului unei macarale.",
                "c) stifturi de siguranta ale unei chei de impreunare."
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "150. Care dintre afirmatiile de mai jos este adevarata?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) tachetii sunt piese metalice formate din doua coloane cilindrice care servesc la luarea voltelor la paramele date ca legaturi la mal",
                "b) tachetii sunt piese metalice in forma de T, montate pe punte, pe copastie si servesc pentru luarea voltelor la parame mai subtiri",
                "c) tachetii sunt piese metalice de ghidarea paramelor, cu minimum de frecare."
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "151. Care dintre afirmatiile de mai jos este adevarata?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) turnichetii sunt piese metalice in forma de T, ce se folosesc la luarea voltelor la diverse parame",
                "b) turnichetii sunt piese metalice de ghidarea paramelor, cu minimum de frecare",
                "c) turnichetii sunt piese metalice pentru agatat lanturi, parame vegetale si sarme."
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "152. Care dintre afirmatiile de mai jos este falsa?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) viteza navei se masoara in noduri.",
                "b) viteza navei se masoara in Mile marine pe ora (Mm/h)",
                "c) viteza navei se masoara cu anemometrul."
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "153. Ce tip de ancora este ancora Amiralitate?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cu fus articulat.",
                "b) cu gheare de pisica.",
                "c) cu fus nearticulat"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "154. Ce tip de ancora este ancora Hall?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cu fus articulat.",
                "b) cu gheare de pisica.",
                "c) cu fus nearticulat"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "155. Cum se masoara greutatea unei parame?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prin masurarea circumferintei ei",
                "b) prin masurarea sarcinii la care se rupe parama",
                "c) prin masurarea greutatii in kilograme a unui metru liniar din parama respectiva"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "156. Cum se masoara grosimea unei parame?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prin masurarea circumferintei ei",
                "b) prin masurarea sarcinii la care se rupe parama",
                "c) prin masurarea greutattii in kilograme a unui metru liniar din parama respectiva"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "157. Cum se masoara rezistenta unei parame?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prin masurarea circumferintei ei",
                "b) prin masurarea sarcinii la care se rupe parama",
                "c) prin masurarea greutatii in kilograme a unui metru liniar din parama respectiva"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "158. Echea reprezinta:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) partea carmei scufundata in apa, care realizeaza efectul de guvernare",
                "b) o piesa sub forma unei bare sau a unui sector ce se fixeaza in capul penei carmei.",
                "c) partea de carma ce se afla deasupra liniei de plutire."
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "159. Elementele componenete ale unei ancore sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nara de ancora, vinciul de ancora si lantul de ancorare.",
                "b) fus, diamant, brate si gheare.",
                "c) stopa de lant, lantul de ancorare si tubul de ghidare."
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "160. Elementele structurale ale unei parame sintetice sau vegetale sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) firul, sfilata, suvita, lantana, cordonul, garlinul.",
                "b) firul, suvita, lantana, cordonul, garlinul, gasa.",
                "c) firul, sfilata, suvita, lantana, cordonul, carlinga."
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "161. In categoria nodurilor speciale intra:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nodul gura de stiuca, nodul de remorca",
                "b) nodul de bandula, nodul picior de caine",
                "c) nodul de scaun, nodul de ancora."
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "162. In categoria obiectelor de armament destinate pentru navigatie din inventarul barcii, intra:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) ghiordel",
                "b) cutit de gabier",
                "c) compas de barca"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "163. In categoria obiectelor de armament destinate pentru navigatie si semnalizare din inventarul barcii, intra:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) pistol de semnalizare",
                "b) butoias cu apa potabila",
                "c) ispol"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "164. In categoria obiectelor de armament destinate pentru navigatie si semnalizare din inventarul barcii, intra:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) colacii de salvare",
                "b) pavilioane de semnalizare cu bratele.",
                "c) veste de salvare"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "165. In categoria obiectelor de armament destinate pentru navigatie si semnalizare din inventarul barcii, intra:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) bastonul de pavilion cu pavilionul",
                "b) ciocanul",
                "c) ghiordelul"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "166. In categoria obiectelor de armament destinate pentru salvare echipaj, in inventarul barcii intra si:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) pistolul de semnalizare",
                "b) butoias cu apa potabila",
                "c) ispolul"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "167. In categoria obiectelor de armament destinate pentru salvare, in inventarul barcii intra si:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) trusa cu scule de marangozerie",
                "b) veste de salvare",
                "c) ispolul"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "168. In categoria obiectelor de armament destinate pentru salvare, in inventarul barcii intra si:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) colaci de salvare",
                "b) ghiordelul",
                "c) compasul de barca"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "169. In categoria obiectelor de armament destinate pentru salvarea personalului, in inventarul barcii intra si:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) trusa cu medicamente",
                "b) trusa cu scule de marangozerie",
                "c) felinar de vant"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "170. In categoria obiectelor de armament destinate pentru vitalitatea barcii, intra si:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) butoias cu apa potabila",
                "b) ghiordelul",
                "c) veste de salvare"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "171. In categoria obiectelor de armament destinate pentru vitalitatea barcii, intra si:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) pavilioane de semnalizare cu bratele.",
                "b) ispolul",
                "c) ciocanul"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "172. In categoria obiectelor de armament destinate pentru vitalitatea barcii, intra si:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) dopuri de lemn",
                "b) bastonul de pavilion cu pavilionul",
                "c) centuri de salvare"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "173. In categoria obiectelor de armament destinate pentru vitalitatea barcii, intra si:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) trusa cu medicamente",
                "b) pene, cuie, calti",
                "c) compasul de barca"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "174. In categoria obiectelor de armament destinate pentru vitalitatea barcii, intra si:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) trusa cu medicamente",
                "b) trusa cu scule de marangozerie",
                "c) felinar de vant"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "175. In categoria propulsoarelor intra:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) zbaturile, ramele, elicele.",
                "b) linia de arbori, bulbul, carma.",
                "c) carma, timona, masina carmei."
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "176. Instalatia de ancorare a navei reprezinta:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un complex de mecanisme care, actionate separat sau in comun, produce momentul giratiei (schimbarea directiei de inaintare a navei)",
                "b) instalatia cu care se realizeaza propulsia navei",
                "c) instalatia cu care se realizeaza fixarea intr- o pozitie bine determinata a navei."
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "177. Instalatia de ancorare:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) reprezinta un ansamblu de piese si mecanisme destinate pentru a realiza deplasarea navei.",
                "b) reprezinta un ansamblu de piese si mecanisme destinate pentru mentinerea navei intr-o zona in afara caii navigabile, sau intr-o pozitie stabila, de catre comandantul navei.",
                "c) reprezinta un ansamblu de piese si mecanisme cu ajutorul carora se asigura nava in locul voit si intr-o pozitie aleasa"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "178. Instalatia de guvernare a navei reprezinta:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) un complex de mecanisme care, actionate separat sau in comun, produce momentul giratiei (schimbarea diretiei de inaintare a navei)",
                "b) instalatia cu care se realizeaza propulsia navei",
                "c) instalatia cu care se realizeaza fixarea intr- o pozitie bine determinata a navei."
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "179. Instalatia de guvernare:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) reprezinta un ansamblu de piese si mecanisme destinate pentru mentinerea navei intr-o zona in afara caii navigabile, sau intr-o pozitie stabila, de catre comandantul navei.",
                "b) reprezinta un ansamblu de piese si mecanisme care trebuie sa asigure respectarea drumului impus navei sau schimbarea directiei navei.",
                "c) reprezintpa un ansamblu de piese si mecanisme destinate pentru a realiza deplasarea navei."
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "180. Instalatia de propulsie a navei:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) reprezinta un ansamblu de piese si mecanisme destinate pentru a realiza deplasarea navei.",
                "b) reprezinta un ansamblu de piese si mecanisme destinate pentru mentinerea navei intr-o zona in afara caii navigabile, sau intr-o pozitie stabila, de catre comandantul navei.",
                "c) reprezinta un ansamblu de piese si mecanisme cu ajutorul carora se asigura nava in locul voit si intr-o pozitie aleasa"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "181. La ce foloseste un palanc dublu?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) pentru multiplicarea fortei de actionare a manevrelor curente de la bord si ridicarea de diferite greutati.",
                "b) pentru dublarea fortei de tractiune a unei fungi",
                "c) pentru ridicarea greutatilor si la instalatiile de gruie."
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "182. Matagonirea reprezinta:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) operatiunea de furbisare a alamurilor de pe nava",
                "b) operatiunea de indepartare a ruginii si a stratului de vopsea sub care se afla rugina.",
                "c) operatiunea de aplicare a grundului pe suprafete curatate de rugina."
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "183. Nodul de ancora este un nod:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) de impreunare",
                "b) de legatura",
                "c) de carlig"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "184. Nodul de capelatura este un nod:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) de legatura",
                "b) de carlig",
                "c) special"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "185. Nodul de scota este un nod:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) de legatura",
                "b) de carlig",
                "c) special"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "186. Nodul de pescar este un nod:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) de impreunare",
                "b) de legatura",
                "c) de carlig"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "187. Nodul de scaun simplu este un nod:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) de impreunare",
                "b) de legatura",
                "c) de carlig"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "188. Nodul de shela este un nod:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) de legatura",
                "b) de carlig",
                "c) special"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "189. Nodul de vacar este un nod:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) de impreunare",
                "b) de legatura",
                "c) de carlig"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "190. Nodul gura de stiuca este un nod:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) de impreunare",
                "b) de legatura",
                "c) de carlig"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "191. Nodul lat este un nod:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) de impreunare",
                "b) de legatura",
                "c) de carlig"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "192. Nodul trebuie sa aiba urmatoarele proprietati:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) usor de facut,usor de desfacut,rezistent,nu deterioreaza parama",
                "b) stabil si strans",
                "c) nu sunt prevazute conditii speciale"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "193. Nodurile de carlig sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nodurile folosite la legarea unui capat de parama de carligul unei macarale",
                "b) nodurile folosite la impreunarea a doua capete de parama de grosimi aproximativ egale.",
                "c) nodurile folosite la fixarea unui capat de parama."
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "194. Nodurile de impreunare sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nodurile folosite la legarea navelor",
                "b) nodurile folosite la impreunarea a doua capete de parama de grosimi aproximativ egale",
                "c) nodurile folosite la fixarea unui capat de parama."
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "195. Nodurile de legatura sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nodurile folosite la legarea unui capat de parama de carligul unei macarale",
                "b) nodurile folosite la impreunarea a doua capete de parama de grosimi aproximativ egale.",
                "c) nodurile folosite la fixarea unui capat de parama."
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "196. Obiectele din alama si bronz se pitureaza?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu",
                "b) da",
                "c) uneori"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "197. Paramele de bumbac sunt folosite la confectionarea baloanelor si paietelor?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu",
                "b) da",
                "c) uneori"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "198. Paramele de bumbac sunt folosite la confectionarea manevrelor curente?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu",
                "b) da",
                "c) uneori"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "199. Paramele de bumbac sunt folosite la confectionarea saulelor la ambarcatiuni sport si de agrement ?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu",
                "b) da",
                "c) uneori"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "200. Paramele de canepa sunt confectionate din fire de canepa?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu",
                "b) da",
                "c) uneori"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "203. Paramele de canepa sunt folosite la confectionarea saulelor la ambarcatiuni sport si de agrement?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu",
                "b) da",
                "c) uneori"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "208. Paramele de sizal sunt confectionate din fire de canepa?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu",
                "b) da",
                "c) uneori"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "209. Vinciul este :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) instalatie fixa",
                "b) mecanism de ridicat sau tras, manual sau actionat mecanic,cu ax orizontal utilizat la bord pentru virarea ancorei,manevrelor unei bigi,a curentilor palancurilor gruelor de barca",
                "c) instalatie mecanica de forta"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "210. Cangea de manevra este utilizata pentru:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) acostare si plecare,prinderea unui inel la geamandura sau debarcader",
                "b) masurarea adancimii apei",
                "c) masurarea vitezei ambarcatiunii"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "213. Cabestanul este :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) instalatie mecanica",
                "b) dispozitiv de manevra",
                "c) Mecanism de punte,pentru virarea ancorei sau manevrarea paramelor,actionat manual sau electro- mecanic, cu ax vertical"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "214. Gruiul este:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) instalatie mecanica",
                "b) suport ambarcatiune",
                "c) dispozitiv de ridicare a greutatilor si a bãrcilor având o formã curbatã,o razã relativ micã de actiune comparativ cu bigile si granicele si o capacitate de ridicare scãzutã"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "216. Principiul lui Arhimede se aplica:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) oricarui corp care zboara",
                "b) oricarui corp aflat la sol.",
                "c) oricarui corp scufundat in apa."
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "217. Rodantele sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) aparatoare ale macaralelor",
                "b) aparatoare ale gaselor",
                "c) dispozitive de vitalitate"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "218. Sabordurile sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) deschideri in bordaj de forma dreptunghiulara, cu destinatii diferite.",
                "b) deschideri in punte de dimensiuni mici, destinate accesului oamenilor in compartimentele aflate sub punte.",
                "c) deschideri in punte destinate pentru iluminarea si aerisirea compartimentului masini si caldari."
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "219. Sarcina la care parama se rupe reprezinta:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) grosimea paramei",
                "b) greutatea paramei",
                "c) rezistenta paramei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "220. Saula \"tin-te\" bine se intalneste la :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) barcile de serviciu",
                "b) barcile de salvare",
                "c) barcile de serviciu si barcile de salvare"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "221. Se poate da a doua mana de vopsea, daca nu s-a uscat primul strat de vopsea?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) da",
                "b) nu",
                "c) nu conteaza"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "222. Sunt elemente componente ale instalatiei de ancorare:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) stopa de lant, vinciul de ancora si nara de punte.",
                "b) babale, parame, turnicheti",
                "c) vinciuri de balansina, balansina si carligul de sarcina"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "223. Sunt elemente componente ale instalatiei de ancorare:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) fungile, bratele si scotele.",
                "b) ancora, nara de ancora si ghidajele de lant.",
                "c) straiurile, sarturile si pataratinele"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "224. Tambuchirile sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) deschideri in punte necesare incarcarii- descarcarii marfii in/din magazii.",
                "b) deschideri in punte de dimensiuni mici, destinate accesului oamenilor in compartimentele aflate sub punte.",
                "c) deschideri in punte, destinate pentru iluminarea si aerisirea compartimentului masini si caldari."
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "225. Timona reprezinta un element component al instalatiei de :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) propulsie",
                "b) guvernare",
                "c) ancorare"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "226. Umezeala altereaza paramele vegetale?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) da",
                "b) nu",
                "c) uneori"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "227. Unde se afla puntirile barcii?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) in prova si in pupa",
                "b) in mijlocul barcii",
                "c) pe fundul barcii."
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "228. Voltele in cadrul lucrarilor de matelotaj sunt:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) noduri marinaresti",
                "b) legaturi prin care se fixeaza paramele la dispozitive speciale de legare",
                "c) intoarceri ale navelor sub actiunea vantului."
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "229. Voltele se pot face la :",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) baba, tacheti, cavile",
                "b) baba, turnicheti, somare",
                "c) baba, galion, goling"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Marinarie",
            "difficulty": 1
        },
        {
            "question": "266. La deplasarea înainte a bărcii, efectul cârmei determină",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) orientarea provei în vânt",
                "b) orientarea provei în bordul în care s-a pus cârma şi a pupei în bordul opus",
                "c) mersul în linie dreaptă"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "267. La marş înainte, pupa este abătută",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) spre dreapta",
                "b) în bordul pasului elicei, iar prova are tendinţa să gireze în bordul opus pasului elicei",
                "c) spre stânga"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "268. Acostarea ambarcaţiunii la mal neamenajat",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu este recomandată",
                "b) se face cu vigilenţă sporită, protejând elicea şi cârma",
                "c) este interzisă"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "269. Depăşirile se execută",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la o distanță cât mai mare de nava depăşită, viteza se adaptează situaţiei, urmărind a nu face valuri pentru nava depăşită, dar acordând atenţia necesară întâmpinării valurilor din siajul acesteia",
                "b) de către ambarcaţiunea care merge pe mijlocul şenalului",
                "c) oricum deoarece nu sunt reguli speciale de siguranţă în cazul acestei manevre"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "270. Remorcarea este o operaţiune la care lungimea parâmei de remorcă",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) se va alege astfel încât nava remorcată să nu suporte curentul respins de elicea navei remorcher",
                "b) nu contează lungimea parâmei de legare",
                "c) nu se fac remorcări cu ambarcaţiuni"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "271. Înainte de pătrunderea în ecluză",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu trebuiesc făcute pregătiri speciale la bordul ambarcaţiunilor",
                "b) la bordul ambarcaţiunilor parâmele trebuie ţinute din scurt şi componentele echipamentului trebuie să nu depăşească limitele navei",
                "c) conducătorul nu are nici o obligaţie"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "272. Din motive de siguranţă şi fluidizare a circulaţiei, pentru accelerarea traversării şi pentru exploatarea în plin a ecluzelor",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) personalul de supraveghere a ecluzelor poate emite ordine care să completeze regulile iniţial prevăzute sau care se abat de la acestea, iar conducătorii navelor trebuie să urmeze aceste ordine în zona de ecluzare",
                "b) personalul de supraveghere a ecluzelor nu are permisiunea de a emite ordine care să completeze regulile iniţial prevăzute",
                "c) este permisă orice măsură propusă de conducătorii navelor"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "273. În funcţie de tipul cocii, viteza bărcii este cu atât mai mare cu cât",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) suprafaţa udată la viteza maximă este mai mare",
                "b) suprafaţa udată la viteza maximă este mai mică",
                "c) elicea are mai multe pale"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "274. Înainte de a părăsi locul de acostare",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) îndepărtaţi orice material în plus din barca şi lăsaţi-l la ţărm; dacă aveţi nevoie de el la bord, asiguraţi-vă că este depozitat în siguranţă",
                "b) nu este nevoie de asemenea pregătire",
                "c) puteţi depozita materialele după libera dvs. alegere"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "275. Alegerea celei mai bune elice şi a înălţimii motorului necesită verificarea câtorva lucruri precum",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) turaţia maximă a motorului; viteza bărcii; ventilaţia elicei; abilitatea de glisare a bărcii; presiunea de răcire",
                "b) lungimea bărcii",
                "c) pescajul şi lăţimea bărcii"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "276. Numărul de ture pe care îl efectuează o elice în mişcarea sa de rotaţie într-un interval de timp de un minut reprezintă",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) numărul de rotaţii al elicei pe minut (RPM)",
                "b) spaţiul parcurs de elice într-un minut",
                "c) viteza de rotaţie a elicei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "277. Legăturile ambarcaţiunii sunt",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) parâma pupa",
                "b) parâma prova şi pupa",
                "c) parâma prova"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "278. Locul de ancorare trebuie să îndeplinească o serie de condiţii",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) să permită o ancorare-plecare uşoară, fără să deranjeze alte ambarcaţiuni",
                "b) nu sunt impuse condiţii speciale pentru ancorare",
                "c) este interzisă ancorarea în afara radelor"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "279. În cazul în care nu putem observa în mod clar felul cum acţionează curentul şi vântul în cazul manevrei de ,,Om la apă”",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu facem manevra de recuperare a celui căzut în apă",
                "b) venim iniţial cu prova pe direcţia inversă a rezultantei, căutând efectul minim de derivă şi ne apropiem de cel căzut în apă cu viteza scăzută",
                "c) nu este nevoie de nici o estimare a efectului curentului si vântului"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "280. În timpul ecluzării, în camerele ecluzelor",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) este interzisă curăţarea şi maturarea navelor şi corpurilor flotante",
                "b) este permisă curăţarea şi maturarea navelor şi corpurilor flotante",
                "c) nu este prevăzută expres această regulă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "281. Conducerea de motovehicule nautice (skyjet) este supusă următoarelor limite",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) motorul nu se opreşte la căderea conducătorului",
                "b) regulile de construcţie privesc pe constructor",
                "c) motorul trebuie sau să se oprească automat la căderea conducătorului, sau să fie cuplat automat pe cea mai mică viteză, în timp ce vehiculul trebuie să se oprească sau să descrie o traiectorie circulară"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "282. Dacă barca dumneavoastră este echipată cu un sistem de cablu împinge- trage, mecanic",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) toate componentele sistemului trebuie să îndeplinească sau să depăşească cererile menţionate în standard",
                "b) componentele sistemului pot fi alese după aprecierea proprietarului",
                "c) nu există reguli şi standarde pentru această instalaţie"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "283. Manevra de oprire se execută astfel",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) in cazul in care nu exista nici un motiv sa faceţi altfel, reduceţi in mod gradat viteza, deoarece reducerea brusca poate face ca valul de pupa sa se lovească de oglinda bărcii si sa se reverse in interior",
                "b) ambarcaţiunea se opreşte rapid, prin punerea pe zero si cuplarea pe înapoi a motorului",
                "c) barca se opreşte din mers prin scoaterea cheii din contact"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "284. Dacă înclinaţi motorul în sus la viteze mari",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu se observa nici un efect",
                "b) forţele turbionare vor acţiona brusc şi pot cauza pierderea controlului ambarcaţiunii",
                "c) barca se înclină în bordul pasului elicei"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "285. La acostare se folosesc",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) baloane de protecţie polivinilice umplute cu aer",
                "b) corpul ambarcaţiunii nu se protejează",
                "c) orice fel de obiecte din metal sau lemn"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "286. Cu cât viteza de deplasare este mai mare",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) presiunea apei asupra penei cârmei va fi mai mare, iar schimbarea direcţiei mai rapidă",
                "b) presiunea apei asupra penei cârmei va fi mai mică, iar schimbarea direcţiei mai înceată",
                "c) viteza nu influenţează rapiditatea schimbării direcţiei de navigaţie"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "287. Mărimea şi forma elicei depinde de",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) turaţia dată la axul elicei",
                "b) puterea motorului, mărimea corpului ambarcaţiunii şi scopul pentru care este destinată barca, tracţiune sau viteză",
                "c) parametrii motorului"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "288. Guvernarea poate fi îmbunătăţită de:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) reducerea numărului de cârme",
                "b) mărimea suprafeţei penei cârmei",
                "c) micşorarea unghiului de rotire a cârmei"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "289. La manevra de acostare, pe lângă calităţile manevriere ale navei, tot timpul se va ţine cont de vânt şi curent urmărindu-se",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) să se evite influenţa lor",
                "b) ca forţa acestora să fie folosită în ajutorul manevrei şi nu manevra săse împotrivească acestora",
                "c) nu se ţine cont de vânt şi curent"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "290. Manevra de ”Om la apă“ este o manevră clasică de recuperare care se efectuează",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) ţinând cont de efectul vântului şi curentului asupra ambarcaţiunii şi persoanei căzute în apă, astfel încât ambarcaţiunea să nu derive peste omul din apă",
                "b) nu este nevoie de nici o estimare a efectului curentului si vântului",
                "c) această manevră o fac numai navele de salvare"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "291. În camerele ecluzei:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu se folosesc baloanele/trancheţi pentru acostare",
                "b) este obligatorie folosirea trancheţilor pentru acostare",
                "c) se folosesc trancheţi care trebuie să fie flotabili, dacă nu sunt legaţi strâns-fixaţi de navă"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "292. Conducerea de motovehicule nautice (skyjet-uri) este supusă următoarelor limite",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) se poate naviga atât ziua cât şi noaptea",
                "b) este permisă numai ziua",
                "c) nu sunt prevăzute reguli exprese"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "293. Indicatorul înclinării este folosit",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la ridicarea cizmei/motorului pentru controlul elicei",
                "b) numai de persoanele autorizate",
                "c) sa orienteze motorul la un unghi predeterminat pentru o performanţă mai bună în navigaţie"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "294. Înainte de a părăsi locul de acostare:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) asiguraţi-vă că operaţiunile de pe algoritmul verificărilor dumneavoastră au fost parcurse",
                "b) nu se fac nici un fel de verificări",
                "c) toate verificările sunt făcute de către un service"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "295. Pasul elicei reprezintă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) mărimea diametrului butucului",
                "b) lungimea palei",
                "c) spaţiul parcurs de marginea exterioară a elicei in mişcarea de translaţie efectuată de-a lungul axei de rotaţie în timpul unei rotaţii complete"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "296. Locul de ancorare trebuie să îndeplinească o serie de condiţii:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) este interzisă ancorarea în afara radelor",
                "b) să fie un loc ferit de efectele curenţilor, valurilor şi vântului",
                "c) nu sunt impuse condiţii speciale pentru ancorare"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "297. În categoria ecluzelor intră:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) ecluzele şi suprafeţele de apă dinăuntrul şi dinafara sasurilor ecluzelor care servesc legării la cheu, înşiruirii şi aşteptării navelor –avanporturile de ecluză",
                "b) barajele şi porţile amonte şi aval",
                "c) numai sasurile ecluzelor"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "298. În timpul ecluzării, în camerele ecluzelor",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) ambarcaţiunile mici pot să staţioneze oriunde in interiorul camerei",
                "b) ambarcaţiunile mici nu au voie să ecluzeze",
                "c) ambarcaţiunile mici trebuie să păstreze suficientă distanţă faţă de alte nave"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "299. Conducerea de motociclete nautice (skyjet) este supusă următoarelor limite:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) conducătorul şi însoţitorul trebuie să poarte veste de salvare",
                "b) conducătorul şi însoţitorul nu trebuie să poarte veste de salvare",
                "c) conducătorul şi însoţitorul nu trebuie să poarte veste de salvare, dacă sunt buni înotători"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "300. Mişcarea transversală a unei nave în jurul unei axe longitudinale reprezintă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) tangaj",
                "b) ruliu",
                "c) mişcare ascensională"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "301. \"Mărimea’’ forţei ce acţionează asupra timonei este influenţată de",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) puterea motorului, de câtă porţiune din elice este în apă, de tipul şi pasul elicei",
                "b) numai de puterea motorului",
                "c) numai de pasul elicei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "302. Instalaţia de guvernare se compune din",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) timonă şi transmisie",
                "b) timona sau manipulatorul electric; servomotorul la navele mari; sistemul de transmisie timonă-servomotor-cârmă; cârma propiu-zisă",
                "c) timona"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "303. Elicea are pas stânga dacă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la mersul înainte al ambarcaţiunii elicea se învârte la dreapta",
                "b) la mersul înapoi al ambarcaţiunii elicea se învârte la dreapta",
                "c) la mersul înainte al ambarcaţiunii elicea se învârte la stânga"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "304. În cazul acostării cu bordul:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nava se apropie de cheu sub un unghi ascuţit, pentru a atenua impactul provei cu cheul",
                "b) ambarcaţiunea se apropie de cheu pe o direcţie perpendiculară pe acesta",
                "c) ambarcaţiunea se apropie de cheu din orice pozitie"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "305. Reuşita ancorării depinde şi de folosirea corectă a lungimii parâmei/lanţului de ancorare şi anume",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu sunt stabilite reguli speciale privind lungimea lanţului/parâmei de ancorare",
                "b) lungimea parâmei/lanţului de ancorare nu influenţează siguranţa ancorării",
                "c) lungimea parâmei/lanţului la ancoră trebuie să fie de 3-5 ori adâncimea"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "306. În zona de ecluzare:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) ancorele trebuie să fie ridicate la post şi asigurate",
                "b) ancorele pot fi folosite în ecluză",
                "c) nu sunt prevăzute reguli speciale pentru acest caz"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "307. O ambarcaţiune este dificil de controlat în timpul navigaţiei dacă este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) echipată cu motoare de puteri mai mari decât cea pentru care a fost proiectată (,,overpower’’)",
                "b) este echipată cu motoare cu putere asemănătoare cu cea pentru care a fost proiectată",
                "c) nu este importantă puterea motorului"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "308. Dacă barca devine instabilă",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) măriţi viteza pentru a stabiliza deplasarea",
                "b) reduceţi viteza în mod gradat, nu acceleraţi, opriţi testul de navigaţie în viteza pe apă, apoi verificaţi barca şi echipamentul, iar în cazul în care consideraţi că este nevoie, contactaţi-vă dealer-ul sau un expert pentru a vă ajuta",
                "c) nu este nevoie de nici o verificare, continuaţi mersul la aceeaşi parametri, deoarece fenomenul de instabilitate dispare după scurt timp"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "309. Pentru alegerea elicei care să corespundă exigenţelor dvs. trebuie să ţineţi cont de următoarele elemente",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) tonajul bărcii",
                "b) experienţa conducătorului",
                "c) viteza probabilă a bărcii, care este cea mai bună elice pentru designul şi viteza bărcii dumneavoastră; modul în care doriţi să folosiţi barca; testarea pasului elicei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "310. Înmulţind rotaţiile pe minut (RPM) cu pasul elicei, se obţine:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) valoarea rezistenţei elicei",
                "b) spaţiul parcurs de ambarcaţiune într-un minut",
                "c) numărul de pale de elice"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "311. Locul de ancorare trebuie să îndeplinească o serie de condiţii:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu sunt impuse condiţii speciale pentru ancorare",
                "b) este interzisă ancorarea în afara radelor",
                "c) să permită plecarea rapidă a navei de la ancoră, în orice condiţii, ziua sau noaptea"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "312. În zona de ecluzare este interzisă depăşirea, navele au voie să treacă pe lângă alte nave care aşteaptă în ecluză:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) atunci când conducătorul sau pasagerii consideră necesar",
                "b) numai atunci când ambarcaţiunile trebuie să fie ecluzate înainte sau pentru a se poziţiona în spaţiile libere aflate la îndemână",
                "c) ori de câte ori conducătorul consideră că este o manevră sigură"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "313. Înainte de pătrunderea în ecluză",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu trebuie făcute pregătiri speciale la bordul ambarcaţiunilor",
                "b) la bordul ambarcaţiunilor parâmele trebuie ţinute din scurt si componentele echipamentului trebuie să nu depăşească limitele navei",
                "c) conducătorul nu are nici o obligaţie"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "314. În timpul ecluzării, în camerele ecluzelor",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) este permis să se lase pasagerii să urce sau să coboare de la bord",
                "b) este interzis să se lase pasagerii să urce sau să coboare fără permisiunea personalului ecluzei",
                "c) nu este prevăzută expres această regulă"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "315. Conducerea de skyjet este supusă următoarelor limite",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) pe skyjet trebuie să se aplice numere de înmatriculare vizibile acordate de căpitănie",
                "b) pe skyjet nu trebuie să se aplice numere de înmatriculare, deoarece nu este loc",
                "c) nu sunt reguli prevăzute expres"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "316. Conducătorul ambarcațiunii:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) poate să dea drumul timonei la orice viteză a bărcii",
                "b) poate să balanseze timona la o viteză mare a bărcii",
                "c) nu ar trebui să dea drumul timonei la nici un fel de viteză, din cauza forţelor turbionare prezente în sistemul de guvernare, barca ar putea să înceapă să se rotească rapid şi să devină instabilă"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "317. Un motor înclinat în sus",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) are o abilitate de frânare mai redusă decât unul înclinat în jos şi este nevoie de mai mult spaţiu pentru a opri barca",
                "b) are o abilitate de a opri mai uşor barca",
                "c) nu are nici un fel de influenţă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "318. Schimbarea direcţiei de deplasare a ambarcaţiunii se realizează prin",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) navigarea în ape cu salinități diferite",
                "b) punerea cârmei într-un bord sau altul şi este determinată de forţa curentului care apasă asupra penei cârmei, sau orientarea propulsorului în cazul propulsiei în ,,Z’’",
                "c) ambarcaţiunea schimbă direcţia când este influenţată de curent şi vânt"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "319. Prin rotaţia elicei se generează efect de",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) propulsie şi guvernare",
                "b) propulsie",
                "c) guvernare"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "320. Dacă înclinaţi motorul în sus la viteze mari",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu se observa nici un efect",
                "b) forţele turbionare vor acţiona brusc şi pot cauza pierderea controlului ambarcaţiunii",
                "c) barca se înclină în bordul pasului elicei"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "321. La trecerea prin avanporturi de ecluză şi la intrarea în ecluze, navele trebuie:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) să-şi micşoreze viteza, pentru a fi posibilă în orice condiţii o oprire sigură cu ajutorul cablurilor de oţel, parâmelor şi a altor măsuri potrivite, astfel încât să fie exclusă o coliziune cu porţile ecluzei sau cu dispozitivele de protecţie.",
                "b) să execute manevra de intrare cu viteza cea mai mare pentru reducerea timpului de staţionare în ecluză",
                "c) nu sunt impuse reguli speciale"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "322. Ordinea ecluzării este",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu există reguli privind ordinea ecluzării",
                "b) navele administraţiei; navele care sunt plecate pentru îndeplinirea unor misiuni excepţionale; navele avariate grav au prioritate la ecluzare in faţa celorlalte, fără a sta la rând; navele de pompieri şi de salvare aflate în drum spre locul accidentului; celelalte nave",
                "c) operatorul ecluzei dispune cum crede de cuviinţă"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "323. O persoană care nu este pregătită pentru operarea unei bărci de mare viteză",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) poate încerca să conducă, crescând succesiv viteza fără instruire din partea unor conducători mai experimentaţi",
                "b) nu este nici o problemă, deoarece nu există riscuri",
                "c) nu ar trebui să încerce să conducă fără o instruire prealabilă şi o aplicaţie practică cu un conducător experimentat sau un dealer, pierderea controlului ar putea avea ca rezultat accidente grave"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "324. Înainte de a părăsi locul de acostare:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu se fac nici un fel de verificări",
                "b) asiguraţi-vă că toate mecanismele folosite pentru a ataşa motorul de barcă sunt bine strânse şi la locul lor, procedaţi la fel pentru toată aparatura din sistemul de guvernare",
                "c) nu sunt reguli prevăzute expres"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "325. Ce fenomene hidrologice şi meteorologice pot influenţa manevra navei?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) vântul, valurile, curentul, adâncimi mari",
                "b) vântul, valurile, curentul",
                "c) vântul, valurile, curentul, adâncimi mici"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "326. În cazul în care ambarcaţiunea dvs. este utilizată în regim de mare viteză în mod constant, este nevoie:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) să alimentaţi mai des barca cu combustibil",
                "b) să schimbaţi uleiul mai des",
                "c) să fie verificate instalaţiile de elevare a motorului, de guvernare şi de cuplare- accelerare, precum şi elicea/elicele, la intervale mai scurte de timp"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "327. În ce constă manevrabilitatea bărcii?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) manevrabilitatea constă în capacitatea bărcii de a-şi menţine direcţia de înaintare sau de a schimba această direcţie cu ajutorul cârmei şi elicei",
                "b) manevrabilitatea consta in incapacitatea bărcii de a-si menţine direcţia de înaintare",
                "c) nu este o definiţie prevăzuta pentru aceasta caracteristica a ambarcaţiunii"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "328. Elicea are pas dreapta dacă:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la mersul înainte al ambarcaţiunii elicea se învârte la dreapta",
                "b) la mersul înapoi al ambarcaţiunii elicea se învârte la dreapta",
                "c) la mersul înainte al ambarcaţiunii elicea se învârte la stânga"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "329. Manevrele de acostare și plecare:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) sunt manevre simple, care nu solicită cunoştinţe de specialitate",
                "b) se fac numai cu piloţi specializaţi",
                "c) prezintă grad sporit de dificultate, solicitând cunoaşterea calităţilor manevriere ale navei și deprinderi marinăreşti"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "330. Reuşita ancorării depinde și de folosirea corectă a lungimii parâmei/lanţului de ancorare și anume:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) lungimea parâmei/lanţului la ancoră trebuie să fie de 3-5 ori adâncimea măsurată",
                "b) nu sunt stabilite reguli speciale privind lungimea lanţului/parâmei de ancorare",
                "c) lungimea parâmei/lanţului de ancorare nu influenţează siguranţa ancorării"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "331. În zona de ecluze navele care sunt dotate cu o instalaţie de emisie–recepţie",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) închid aparatul VHF",
                "b) folosesc canalul pe care îl consideră util",
                "c) trebuie să aibă comutat la recepţie canalul ecluzei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "332. În timpul ecluzării, în camerele ecluzelor:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) este permis să se folosească după legarea navei și până la permiterea ieşirii atât propulsia mecanică, cât și instalaţia de guvernare prova",
                "b) nu este prevăzută expres această regulă",
                "c) este interzis să se folosească după legarea navei și până la permiterea ieşirii atât propulsia mecanică, cât și instalaţia de guvernare prova; din motive de siguranţă acest lucru este permis numai pentru fracţiuni scurte de timp"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "333. Motorul ataşabil al unei ambarcaţiuni se montează",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) având placa anticavitație la nivelul chilei ambarcaţiunii",
                "b) având placa anticavitație deasupra nivelului chilei ambarcaţiunii, la decalajul maxim permis de dispozitivul de fixare a motorului și dimensiunile oglinzii bărcii",
                "c) se poate monta oricum, deoarece nu sunt influenţaţi parametrii de mişcare ai bărcii"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "334. În cazul în care ambarcaţiunea dvs. este utilizată în regim de mare viteză în mod constant, este nevoie:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) să alimentaţi mai des barca cu combustibil",
                "b) să schimbaţi uleiul mai des",
                "c) să fie verificate instalaţiile de elevare a motorului, de guvernare şi de cuplare- accelerare, precum şi elicea/elicele, la intervale mai scurte de timp"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "335. La deplasarea înapoi a bărcii, efectul cârmei determină",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu are nici o influenţă",
                "b) orientarea provei în bordul în care s-a pus cârma şi a pupei în sensul opus cârmei",
                "c) orientarea provei în bordul opus celui în care s-a pus cârma şi a pupei în sensul punerii cârmei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "336. La marş înapoi, pupa este abătută:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) în bordul opus pasului elicei, iar prova va gira în bordul pasului elicei",
                "b) spre stânga",
                "c) spre dreapta"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "337. Acostarea ambarcaţiunii la o navă se face în următoarele condiţii",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nava la care urmează a se acosta reduce viteza și păstrează direcţia fără abatere, iar ambarcaţiunea va acosta totdeauna în bordul de sub vânt şi cât mai spre centrul navei",
                "b) nu contează condiţiile",
                "c) aceasta manevră este interzisă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "338. La întâlniri, conducătorul ambarcaţiunii",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) păstrează direcţia şi viteza de deplasare",
                "b) va reduce viteza în întâmpinarea valurilor provocate de nava ce vine din sens opus şi va adopta o viteză corespunzătoare evitării răsturnării",
                "c) se vor evita constant întâlnirile"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "339. În camerele ecluzei",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) navele trebuie să se menţină în interiorul limitelor, în cazul în care pe pereţii ecluzelor sunt marcate graniţe/limite",
                "b) navele se pot lega oriunde consideră",
                "c) nu este nevoie de legarea navelor în timpul ecluzării"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "340. Schiul nautic pe căile navigabile interioare este permis",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) numai în zonele stabilite şi marcate, acest lucru fiind valabil şi pentru activităţi în care persoanele sunt trase de o ambarcaţiune fără schiuri nautice sau pe altfel de obiecte",
                "b) fără restricţie de zonă, deoarece ambarcaţiunile au o viteză mare",
                "c) nu sunt reguli prevăzute special pentru schiul nautic"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "341. Când motorul este înclinat în jos la capătul cursei",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) barca glisează orizontal pe apă",
                "b) pupa bărcii va intra mai adânc în apă, la ambarcaţiunile mai mici se observă apuparea",
                "c) înclinarea motorului/cizmei nu influenţează alura deplasării"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "342. Pasul elicei reprezintă",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) mărimea diametrului butucului",
                "b) lungimea palei",
                "c) spaţiul parcurs de marginea exterioară a elicei, în mişcarea de translaţie efectuată de-a lungul axei de rotaţie în timpul unei rotaţii complete"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "343. Guvernarea clasică poate fi ajutată prin instalarea în corpul ambarcaţiunii de",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) propulsoare prova şi pupa (bowtruster si sterntruster)",
                "b) reducerea suprafeţei penei cârmei",
                "c) micşorarea unghiului de rotire a cârmei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "344. Conducerea de skyjet pe căile navigabile interioare",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) este interzisă",
                "b) este permisă numai în porţiunile stabilite şi marcate",
                "c) nu sunt reguli expres enunţate"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "345. Dacă barca pe care aţi cumpărat-o nu are placa de capacitate",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu este nici o problemă, parametrii limită de exploatare pot fi apreciaţi",
                "b) contactaţi dealer-ul dumneavoastră sau producătorul bărcii, pentru a intra în posesia informaţiilor garantate",
                "c) calculaţi dumneavoastră datele de care aveţi nevoie"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "346. Înainte de a părăsi locul de acostare",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) verificaţi funcţionarea butonului pentru oprire de urgenţă, daţi drumul motorului, trageţi saula şi vedeţi dacă motorul se opreşte; asiguraţi-vă că saula este bine legată de hainele sau vesta dumneavoastră de salvare",
                "b) nu se fac nici un fel de verificări",
                "c) nu trebuie legată saula de haine sau vesta de salvare"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "347. Dacă pupa intră adânc în apă, datorită înclinării motorului la viteze mari",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) barca ar putea să înceapă să se rotească rapid şi să se arunce pasagerii peste bord",
                "b) barca îşi măreşte stabilitatea de drum",
                "c) nu se observă nici un efect"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Manevra",
            "difficulty": 1
        },
        {
            "question": "1. Care este durata maximă a masajului cardio-respitator?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 30 - 40 min",
                "b) 10 - 15 min",
                "c) 60 min"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "2. Care este prima acțiune întreprinsă la acordarea primului ajutor victimelor unei coliziuni?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) spalarea plăgilor",
                "b) dezinfectarea și pansarea rănilor",
                "c) degajarea căilor respiratorii și asigurarea funcției respiratorii"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "3. Care este prima măsură pe care o luați în cazul accidentării unei persoane pe apă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) transportul imediat până la prima localitate și anunțarea la 112",
                "b) transportul la cel mai apropiat spital",
                "c) acordarea primului ajutor până la sosirea cadrelor de pe ambulanță"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "4. Care este rolul bandajului?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) să prevină murdărirea hainelor",
                "b) să împiedice hemoragia",
                "c) să împiedice intrarea corpilor străini în rană"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "5. Care poate fi cauza obturării căilor respiratorii după o coliziune?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) inflamarea mucoasei nazale",
                "b) poziția necorespunzătoare în care a fost așezată victima",
                "c) intrarea unor corpi străini în nasul sau gura victimei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "6. Care sunt simptomele unei fracturi a membrelor?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) temperatura ridicată a membrului fraturat",
                "b) decolorarea zonei fraturate",
                "c) poziția nefirească a membrului respectiv miscarea nenaturală"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "7. Care tip de hemoragie este cea mai periculoasă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) hemoragia arterială",
                "b) hemoragia venoasă",
                "c) hemoragia care determină o pierdere rapidă a sângelui"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "8. Ce criterii trebuie să îndeplinească o atelă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) să fie suficient de lungă pentru a imobiliza articulațiile superioară și inferioară a membrului fracturat și să fie rigidă",
                "b) să fie rigidă",
                "c) să fie sterilă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "9. Ce manevre se fac pentru a acorda primul ajutor în caz de fracturi de membre?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) se imobilizează membrul în atele care să fie destul de lungi pentru a cuprinde articulația de deasupra și cea de dedesubtul fracturii",
                "b) se unesc capetele oaselor care au ieșit prin piele, apoi se bandajează locul",
                "c) se aplică un garou deasupra fracturii"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "10. Ce măsuri de iau în cazul victimelor cu fracturi de claviculă (umărul victimei este deplasat usor înainte și în jos?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) aduceți umărul în poziție normală",
                "b) culcați victima pe spate",
                "c) suspendați brațul într-o eșarfă sau chingă delată de gât"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "11. Ce măsuri de prim ajutor se iau în cazul victimelor care nu mai au puls?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) se efectuează doar masaj cardiac",
                "b) se efectuează doar respirație artificială",
                "c) se efectuează masaj cardio respirator"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "12. Ce măsuri de prim ajutor se iau în cazul victimelor care prezintă o entorsă a gleznei?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) se aplică un bandaj elastic strâns, eventual se aplică și gheață",
                "b) se imobilizează glezna cu atele",
                "c) se transportă urgent victima la mal"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "13. Ce măsuri de prim ajutor se iau în cazul victimelor care prezintă plăgi tăiate?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) se transportă de urgență victima la spital",
                "b) se coase plaga",
                "c) se oprește hemoragia și se transportă victima la spital"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "14. Ce măsuri de prim ajutor se iau în cazul victimelor care și au pierdut cunoștința?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) se verifică existența pulsului și a respirației",
                "b) se administrează medicamente de resuscitare",
                "c) se imobilizează membrele"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "15. Ce măsuri de prim ajutor se iau în cazul victimelor cu traumatisme ale coloanei vertebrale, daca funcțiile vitale ale acesteia sunt asigurate?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) se transportă imediat victima la spital cu orice mijloc de transport aflat la îndemână",
                "b) se transportă imediat victima la spital așezată pe o platformă improvizată",
                "c) dacă nu există un alt pericol, nu se mișcă accidentatul din poziția în care se află până la sosirea serviciilor de urgență"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "16. Ce rol au bandajele?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) imobilizează fracturile",
                "b) dezinfectează rănile",
                "c) acoperă rănile, eventual opresc hemoragiile"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "17. Ce trebuie să urmăriți la scoaterea victimelor dintr o ambarcațiune accidentată?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) să nu produceți pagube suplimentare ambarcațiunii accidentate",
                "b) să nu le agravați leziunile",
                "c) să conservați urmele accidentului"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "18. Cu ce se pot transporta la spital victimele unui accident naval, după ce au fost scoase la mal?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) Cu orice vehicul, dacă situația victimei permite acest lucru",
                "b) numai cu ambulanța SMURD",
                "c) cu o ambulanță însoțită de un medic specialist"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "19. Cum extrageți corpii străini din interiorul plăgilor?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prin spalare cu apă",
                "b) prin extragere cu mâna",
                "c) renunțăm la asemenea manevră întrucât riscăm să agravăm starea victimei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "20. Cum pot fi recunoscute fracturile la membrele victimelor unei coliziuni?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prin elasticitatea exagerată a membrului fracturat",
                "b) prin culoarea roșie a zonei fracturate",
                "c) prin mișcarea nenaturală a membrului fracturat"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "21. Cum procedați dacă în timpul masajului cardio-respirator victima își recapătă pulsul?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) continuați compresiile exterioare ale pieptului",
                "b) încetați compresiile exterioare ale pieptului",
                "c) continuați cu respirație artificială"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "22. Cum procedați pentru a evita complicațiile în cazul unei fracturi?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) suspendați zona fracturată cu o fașă",
                "b) imobilizați zona fracturată",
                "c) sterilizați zona fracturată"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "23. Cum se imobilizează fractura labei piciorului?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cu o atelă de la gleznă până la genunchi",
                "b) prin fixarea piciorului într-o chingă de piele",
                "c) cu atele sau bandaj, cât mai rigide, de la degete până la genunchi"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "24. Cum se imobilizează membrele superioare care au suferit fracturi?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cu o eșarfă",
                "b) cu o legătură elastică",
                "c) cu atele, chiar improvizate"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "25. Cum se poate imobiliza o fractură fără atele?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cu carton",
                "b) cu folie de material plastic",
                "c) cu eșarfe și triunghiuri de pânză"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "26. Cum se recunoaște o fractură deschisă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) zona fracturată nu se poate mișca",
                "b) zona fracturată este înroșită",
                "c) pielea este străpunsă în zona fracturii și se vede osul"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "27. Cum trebuie așezat accidentatul care prezintă hemoragie externă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) astfel încât zona să fie mai jos decât nivelul corpului",
                "b) astfel încât zona să fie mai sus decât nivelul corpului",
                "c) cu picioarele mai sus decât nivelul capului"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "28. Cum trebuie așezată o persoană rănită care prezintă leziuni ale coloanei vertebrale?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) dacă este posibil, victima nu trebuie mișcată până la sosirea medicului",
                "b) orizontal, cu fața în jos",
                "c) orizontal, cu fața în sus"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "29. Cum trebuie resuscitată o victimă a unei coliziuni, care are puls, dar nu respiră?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prin aplicarea de palme peste fața victimei",
                "b) prin masaj cardio-respirator",
                "c) prin executarea respirației artificiale"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "30. Cum trebuie să fie atela destinată imobilizării unei fracturi?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) flexibilă",
                "b) cât mai rigidă și suficient de lungă pentru a cuprinde articulațiile superioară și inferioară a membrului fracturat",
                "c) cât mai scurtă pentru a nu incomoda rănitul"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "31. Cum veți proceda dacă victima căreia i-ați efectuat masaj cardio- respirator își revine?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) așteptați să vedeți cum evoluează starea ei de sănătate",
                "b) o conduceți la mal",
                "c) luați măsuri pentru transportarea ei la spital"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "32. Hemoragia nazală a unei victime se poate opri dacă aceasta:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) stă culcată cu mâna stângă ridicată deasupra capului",
                "b) stă culcată cu capul dat pe spate",
                "c) își strânge ambele nări cu degetele timp de aproximativ 5-10 minute"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "33. În cazul unei coliziuni din care au rezultat mai multe victime, primul ajutor se acordă mai întâi:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) victimei cu cele mai mari șanse de supraviețuire",
                "b) victimei care comunică ușor",
                "c) victimei în starea cea mai gravă"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "34. În ce constă primul ajutor în caz de traumatism al capului?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) aplicarea unor comprese pe frunte și pansarea părților tumefiate",
                "b) imobilizarea capului cu un dispozitiv improvizat",
                "c) bandajarea plăgilor, degajarea căilor respiratorii, așezarea victimei pe o suprafață plană"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "35. În ce loc se execută degajarea căilor respiratorii ale victimei unei coliziuni?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) la locul producerii coliziunii, cât mai urgent",
                "b) la spital, cu instrumente speciale",
                "c) la sosirea ambulanței, de către personalul specializat"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "36. În ce ordine se va lua măsurile de prim ajutor în funcție de starea victimei?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) oprirea hemoragiei, respirație artificială, masaj cardiac, pansarea rănilor, imobilizarea fracturilor",
                "b) pansarea rănilor, imobilizarea fracturilor, oprire hemoragie, respirație artificială, masaj cardiac",
                "c) imobilizarea fracturilor, pansarea rănilor, respirație artificială, masaj cardiac, oprirea hemoragiei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "37. Masajul cardio-respirator trebuie efectuat victimelor:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) care nu respiră",
                "b) care nu au puls și nu respiră",
                "c) care au suferit traumatisme craniene"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "38. Transportul victimelor unei coliziuni care prezintă hemoragii se face?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) imediat după oprirea hemoragiei",
                "b) imediat după pansarea rănilor",
                "c) imediat după anunțarea coliziunii"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "39. Unde se verifică dacă victima unei coliziuni are puls, dacă aceasta respiră?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) lângă mărul lui Adam, în scobitura dintre trahee și mușchii gâtului",
                "b) în zona inimii",
                "c) la încheietura mâinii"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "40. Unde trebuie aplicat garoul de cauciuc în cazul persoanelor rănite care prezintă plăgi însoțite de hemoragii arteriale?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) peste plagă",
                "b) sub plagă",
                "c) deasupra plăgii"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "41. Substanțele antiseptice se folosesc pentru:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) calmarea durerilor",
                "b) dezinfectarea rănilor",
                "c) oprirea hemoragiei"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "42. Victima care a pierdut mult sânge trebuie să fie așezată:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) cu fața în sus",
                "b) cu picioarele situate mai sus decât restul corpului",
                "c) cu fața în jos"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "43. În cazul rănilor cu hemoragie se va avea în vedere la început:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) pansarea rănii",
                "b) curățarea și pansarea rănii",
                "c) oprirea hemoragiei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "44. Când gura unui rănit rămâne încleștată respirația artificială se poate face?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prin gura închisă a victimei",
                "b) prin nările victimei",
                "c) nu se mai face respirație artificială în acest caz"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "45. Cât poate fi menținut un garou pentru a nu afecta țesuturile?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) minimum 2 ore",
                "b) maximum 4 ore",
                "c) maximum 2 ore"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "46. Dezinfectarea plăgilor ce necesită a fi pansate se face cu:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) apă oxigenată sau iod",
                "b) ser fiziologic",
                "c) apă potabilă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "47. Cum se opresc hemoragiile la trunchi și cap?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) prin aplicarea unui garou de cauciuc",
                "b) prin orice mijloace",
                "c) compreselor sterile și a pansamentelor compresive"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "48. Cum procedați în cazul unei victime cu multiple arsuri pe cap și membre?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) arsurile se spală, se bandajează și apoi victima este transportată la cea mai apropiată unitate medicală",
                "b) după stingerea flăcărilor persoana este dezbrăcată rapid de hainele arse",
                "c) trebuie să fie transportată imediat la o unitate medicală"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "49. Biletul care se prinde lângă garoul aplicat unei persoane rănite trebuie să conțină:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) poziția în care a fost găsită victima",
                "b) ora și minutul aplicării garoului",
                "c) numele persoanei care l-a aplicat"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "50. Ce trebuie să conțină un pansament aplicat pe plagă?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) o compresă de tifon steril",
                "b) o compresă de orice tip",
                "c) o compresă de vată sterilă"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-PrimAjutor",
            "difficulty": 1
        },
        {
            "question": "1. Care din următoarele fapte constituie infracțiune?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) îmbarcarea de pasageri peste limita admisă",
                "b) schimbarea poziției, scoaterea din funcțiune, avarierea gravă sau distrugerea unui semnal de navigație",
                "c) nerespectarea dispozițiilor personalului de la ecluze"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Legislatie",
            "difficulty": 1
        },
        {
            "question": "2. Care dintre următoarele fapte constituie infracțiune?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) necomunicarea unor informații",
                "b) refuzul de a pune la dispoziția ANR documente și date necesare investigării",
                "c) împiedicarea îndeplinirii atribuțiilor de serviciu ale personalului navigant"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Legislatie",
            "difficulty": 1
        },
        {
            "question": "3. Care este cauza agravantă a infracțiunii de preluare fără drept a comenzii sau controlului unei nave?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) dacă fost făcută în scopul devierii navei de la itinerarul său",
                "b) dacă a fost făcută de către un membru al echipajului",
                "c) dacă a fost făcută de două sau mai multe persoane"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Legislatie",
            "difficulty": 1
        },
        {
            "question": "4. Luarea în stăpânire a unei platforme fixe sau exercitarea controlului asupra acesteia constituie infracțiune?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) da, dacă s a produs prin violență ori amenințare cu violența",
                "b) da, dacă s a produs în scopul devierii de la itinerarul său",
                "c) da, dacă s-a perturbat funcționarea acesteia sau s-a pus în pericol siguranța navigației"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Legislatie",
            "difficulty": 1
        },
        {
            "question": "5. Ce reprezintă blocarea șenalului navigabil a unei dane sau a bazinului portuar și neexecutarea ordinului căpitanului portului privind măsurile de deblocare?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) contravenție, dacă este fără urmări",
                "b) infracțiune",
                "c) infracțiune, dar numai dacă a avut ca urmare întreruperea navigației ori a activității portuare"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Legislatie",
            "difficulty": 1
        },
        {
            "question": "6. Ultrajul săvârșit împotriva personalului operativ al căpităniei portului, constituie infracțiune?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) da, dacă persoana se află în exercițiul funcțiunii",
                "b) da, chiar dacă este ca urmare a unor fapte îndeplinite în afara exercițiului funcțiunii",
                "c) da, dacă are ca urmare punerea în pericol a siguranței navigației"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Legislatie",
            "difficulty": 1
        },
        {
            "question": "7. În ce termen trebuie transcris contractul de construcție al unei nave în registrul de evidență al navelor în construcție?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 15 zile de la începerea construcției",
                "b) 15 zile înainte de începerea construcției",
                "c) 15 zile înainte de finalizarea construcției"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Legislatie",
            "difficulty": 1
        },
        {
            "question": "8. Care este termenul în care proprietarul unei nave are obligația de a înmatricula nava?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 15 zile",
                "b) 30 zile",
                "c) 60 zile"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Legislatie",
            "difficulty": 1
        },
        {
            "question": "9. Care este termenul limită pentru depunerea la căpitănia portului a actului de naționalitate de către proprietar în cazul suspendării dreptului de arborare a pavilionului român?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) 15 zile de când decizia a rămas definitivă",
                "b) 30 de zile de la comunicarea deciziei",
                "c) 15 zile de la comunicarea deciziei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Legislatie",
            "difficulty": 1
        },
        {
            "question": "10. Exploatarea în scopuri comerciale a ambarcațiunii de agrement, cu excepția celor autorizate în acest sens, constituie:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) infracțiune, dacă periclitează siguranța navigației",
                "b) contravenție la regimul siguranței navigației",
                "c) infracțiune, dacă se depășește numărul maxim de pasageri"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Legislatie",
            "difficulty": 1
        },
        {
            "question": "11. Folosirea de către proprietar a unui nume, număr de identificare sau port de înmatriculare ce nu a fost aprobat de Autoritatea competentă constituie:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) contravenție",
                "b) infracțiune la regimul înmatriculări navelor",
                "c) contravenție, dacă nava a fost depistată pe șenalul navigabil"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Legislatie",
            "difficulty": 1
        },
        {
            "question": "12. Care este sancțiunea pentru nerespectarea ”Avizelor către navigatori”?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) amendă de la 20.000 la 50.000 lei",
                "b) amendă de la 5.000 la 10.000 lei",
                "c) amendă de la 10.000 la 20.000 lei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Legislatie",
            "difficulty": 1
        },
        {
            "question": "13. Care este sancțiunea pentru navigația în zone nepermise a unei nave?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) amendă de la 20.000 la 50.000 lei",
                "b) amendă de la 5.000 la 20.000 lei",
                "c) amendă de la 10.000 la 20.000 lei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Legislatie",
            "difficulty": 1
        },
        {
            "question": "14. Care este sancțiunea pentru așezarea de plase ori unelte fixe de pescuit în apele naționale navigabile precum și în rade, portur,i canale sau senale navigabile?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) amendă de la 10.000 la 30.000 lei",
                "b) amendă de la 5.000 la 10.000 lei",
                "c) amendă de la 5.000 la 20.000 lei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Legislatie",
            "difficulty": 1
        },
        {
            "question": "15. Care este sancțiunea pentru folosirea mijloacelor de semnalizare de la bord în mod nejustificat sau neadecvat regulamentelor de navigație?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) amendă de la 5.000 la 10.000 lei",
                "b) amendă de la 5.000 la 20.000 lei",
                "c) amendă de la 10.000 la 20.000 lei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Legislatie",
            "difficulty": 1
        },
        {
            "question": "16. Care este sancțiunea pentru poluarea apelor naționale navigabile cu hidrocarburi?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) amendă de la 5.000 la 20.000 lei",
                "b) amendă de la 1.000 la 8.000 lei",
                "c) amendă de la 20.000 la 40.000 lei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Legislatie",
            "difficulty": 1
        },
        {
            "question": "17. Care este sancțiunea pentru refuzul prezentării documentului de atestare reprezentanților ANR?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) amendă de la 2.000 la 5.000 lei",
                "b) amendă de la 1.000 la 5.000 lei",
                "c) amendă de la 500 la 8.000 lei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Legislatie",
            "difficulty": 1
        },
        {
            "question": "18. Care este sancțiunea pentru neanunțarea de către conducătorul unei nave cu privire la evenimentele de navigație ale propriei nave cum ar fi: abordaje, coliziuni, incendii, poluare, scufundare?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) amendă de la 40.000 la 50.000 lei",
                "b) amendă de la 5.000 la 10.000 lei",
                "c) amendă de la 5.000 la 20.000 lei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Legislatie",
            "difficulty": 1
        },
        {
            "question": "19. Care este sancțiunea pentru nearborarea la la bordul navei a pavilionului național în apele naționale navigabile ale României?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) amendă de la 2.000 la 5.000 lei",
                "b) amendă de la 1.000 la 5.000 lei",
                "c) amendă de la 5.000 la 20.000 lei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Legislatie",
            "difficulty": 1
        },
        {
            "question": "20. Cum se sancționează refuzul de a se supune cercetărilor întreprinse de ANR sau de a pune la dispoziția ANR documentele și datele necesare investigării:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) amendă de la 1.000 la 5.000 lei",
                "b) amendă de la 30.000 la 50.000 lei",
                "c) amendă de la 10.000 la 20.000 lei"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Legislatie",
            "difficulty": 1
        },
        {
            "question": "21. Cum se sancționează refuzul de a se supune controlului ANR",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) amendă de la 1.000 la 5.000 lei",
                "b) amendă de la 5.000 la 20.000 lei",
                "c) amendă de la 20.000 la 30.000 lei"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Legislatie",
            "difficulty": 1
        },
        {
            "question": "22. Nepredarea la ANR în termen de 5 zile de la comunicarea deciziei de suspendare sau anulare a documentului de atestare se sancționează:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) amendă de la 100 la 500 lei",
                "b) amendă de la 100 la 1.000 lei",
                "c) amendă de la 1.000 la 5.000 lei"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Legislatie",
            "difficulty": 1
        },
        {
            "question": "23. Constatarea contravențiilor și aplicarea sancțiunilor prevăzute de HG 1704/2024 se face de către:",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) personalul împuternicit al ANR",
                "b) personal ANR în asistență reprezentant poliție transporturi navale",
                "c) personalul ANR în asistență reprezentant Administrația Portuară"
            ],
            "correctAnswer": [
                1
            ],
            "section": "D-Legislatie",
            "difficulty": 1
        },
        {
            "question": "24. Se poate constata contravenția fără oprirea navei?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) da",
                "b) nu",
                "c) da, dacă săvârșirea contravenției este probată cu un mijloc tehnic"
            ],
            "correctAnswer": [
                3
            ],
            "section": "D-Legislatie",
            "difficulty": 1
        },
        {
            "question": "25. Se poate constata contravenția în lipsa contravenientului?",
            "questionType": "text",
            "answerSelectionType": "single",
            "messageForCorrectAnswer": "Corect",
            "messageForIncorrectAnswer": "Incorect",
            "point": 1,
            "answers": [
                "a) nu",
                "b) da, dacă săvârșirea contravenției este probată cu un mijloc tehnic",
                "c) da"
            ],
            "correctAnswer": [
                2
            ],
            "section": "D-Legislatie",
            "difficulty": 1
        }
    ]
};
